module.exports = __webpack_public_path__ + "static/four-nine-user-avatar-icon-ba81ac134aa5bede5184539778c6ac1c.svg";